export interface ITicket {
    ticketId: number;
    encryptedTicketId: string;
    supportCategoryId: number;
    assignedTo?: number;
    description: string;
    attachment: string;
    supportConversation: string;
    raisedBy?: number;
    mobile: string;
    issueWith: string;
    raisedByName: string;
    assignedToName: string;
    startDate?: Date;
    endDate?: Date;
    thumbnailUrl: string;
    priority: string;
    status: string;
    conversation: string;
    active: boolean;
    ticketNumber: string;
    roleName: string;
    createdDate: Date;
    dueDate: Date;
    dueTime: Date;
    dueDateTime: string;
    hours: string;
    hourComment: string;
    ownerName: string;
    totalItems: number;
}

